import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

export default function () {
  return new VueI18n({
    locale: 'nl', // set locale
    messages: {
      nl: {
        //Some strings comming from services
        serviceMessages: {
          'Invalid login': 'Ongeldige login',
          'Missing credentials': 'Ontbrekende gegevens',
          'No auth token': 'U moet ingelogd zijn om door te gaan',
          missing_input_data:
            'Some of the fields needed for calculations have no value or have invalid value. Please fill in all the fields.',
          user_account_inactive:
            'Sorry je account is nog niet actief, wanneer wij de betaling hebben ontvangen en verwerkt zullen we je op de hoogte stellen dat je kunt inloggen en deelnemen aan het Geef ze de Vijf platform.',
          inactive_contact_us:
            'Neem dan contact op met ons Geef ze de vijf team',
        },
        message: {
          login_form_title: 'Inloggen',
          password: 'Wachtwoord',
          login_button: 'Log in',
          close: 'sluiten',
          register_form_title: 'Gebruikersregistratie',
          first_name: 'Voornaam',
          insertion: 'Tussenvoegsel',
          last_name: 'Achternaam',
          sex: 'Geslacht',
          birth_date: 'Geboortedatum',
          birth_date_hint: 'bijv. 31/03/1970',
          phone: 'Mobiel',
          email: 'E-mailadres',
          select_user_role: 'Selecteer gebruiksrol',
          select_user_subscription: 'Selecteer abonnement',
          new_password: 'Nieuw Wachtwoord',
          confirm_password: 'Herhaal Wachtwoord',
          agree_with_privacy_statement:
            'Ik ga akkoord met de <a href="/20180601_privacyverklaring.pdf" target="_blank">privacy verklaring</a>',
          privacy_statement: 'privencyverklaring',
          receive_newsletter:
            'Ik ga akkoord voor het ontvangen van de nieuwsbrief',
          select_company: 'Selecteer bedrijf',
          register_button: 'Registreren',
          user_role_owner: 'Melkveehouder',
          user_role_collaborator: 'Medewerker melkveehouderijbedrijf',
          user_role_consultant: 'Erfbetreder',
          user_role_student: 'Student',
          user_role_admin: 'Admin',
          user_subscription_standard: 'Discussieplatform',
          user_subscription_extensive: 'Project geef ze de vijf',
          user_subscription_watch: 'Platform voor erfbetreders',
          user_subscription_student: 'Kennis- en informatieplatform',
          user_profile_updated: 'Gebruikersinformatie opgeslagen',
          sex_female: 'Vrouw',
          sex_male: 'Man',
          sex_undefined: 'Niet gespecificeerd',
          required_field: 'Veld is verplicht',
          invalid_email: 'Email is ongeldig',
          agreement_required: 'Ga akkoord met de privacyverklaring',
          passwords_mismatch: 'Wachtwoorden komen niet overeen',
          general_form_error: 'Het formulier bevat fouten',
          targetDate: 'Streefdatum',
          save: 'Opslaan',
          draft_submit_button: 'Concept indienen',
          confirm_draft_submit_title:
            'Weet je zeker dat je een concept wilt indienen?',
          confirm_draft_submit_text:
            'Nadat u het concept hebt verzonden, kunt u het niet meer bewerken.',
          draft_submit_dialog_no_button: 'Nee',
          draft_submit_dialog_yes_button: 'Ja, indienen',
          user_role: 'Gebruiksrol',
          user_subscription: 'Abonnement',
          newsletter: 'Nieuwsbrief',
          created: 'Toegevoegd',
          yes: 'Ja',
          no: 'Nee',
          all: 'Alle',
          rows_per_page: 'Rijen per pagina',
          std_val_date: 'Datum',
          std_val_priceCalf: 'Prijs kalf',
          std_val_yieldOfCulledCow: 'Opbrengst<br>afgevoerde koe',
          std_val_vemNeedPerDayDryPeriod: 'VEM behoefte per<br>dag droogstand',
          std_val_dveNeedPerDayDryPeriod: 'DVE behoefte per<br>dag droogstand',
          std_val_standardPer24MonthsRearing: 'Norm per 24<br>maanden opfok',
          std_val_otherBreedingCosts: 'Overige fokkerij kosten<br>per dracht',
          standard_values_title: 'Standaardwaarden',
          add_rolling_value: 'Add rolling values',
          rolling_values_title: 'Rolling',
          rolling_val_date: 'Datum',
          rolling_val_protein: 'Eiwit',
          rolling_val_fat: 'Vet',
          rolling_val_lactose: 'Lactose',
          rolling_val_KVEMPriceInMill: 'KVEM prijs<br>in eurocent',
          rolling_val_KVEMPriceInEuro: 'Euro per<br>KVEM',
          rolling_val_KDVEPriceInMill: 'KDVE prijs<br>in eurocent',
          rolling_val_KDVEPriceInEuro: 'Euro per<br>KDVE',
          average_values_title: 'Average values',
          add_average_value: 'Add average values',
          average_val_date: 'Datum',
          average_val_actualLifeBalance: 'Actuele levenssaldo per koe',
          average_val_lifeBalance: 'Levenssaldo bij afvoer per koe',
          average_val_rollingAnualAvgProduction:
            'Rollend jaargemiddelde productie',
          average_val_avgHerdLifePerCow: 'Actuele levensduur',
          average_val_productiveLifespan: 'Actuele productieve levensduur',
          average_val_lifelongProductionPerCow: 'Actuele levensproductie',
          average_val_lifespanCulling: 'Levensduur bij afvoer',
          average_val_productiveLifespanCulling:
            'Productieve levensduur bij afvoer',
          average_val_lifespanProduction: 'Levensproductie bij afvoer',
          add_standard_value: 'Standaardwaarden toevoegen',
          default_currency: '€',
          dashboard: 'Dashboard',
          dashboard_monitor: 'Levensduurmonitor',
          targets: 'Streefwaarden',
          targets_list_title: 'Streefwaarden overzicht',
          indicator_list: 'Huidige situatie',
          indicator_list_title: 'Huidige situatie overzicht',
          users: 'Gebruikers',
          profile: 'Profiel',
          logout: 'Uitloggen',
          draft_submitted_for_approval: 'Concept ingediend ter goedkeuring.',
          targets_not_approved_yet:
            'De streefwaarden worden ter goedkeuring voorgelegd, deze zijn nog niet goedgekeurd.',
          fill_in_targets_button: 'Vul je streefwaarden in >',
          fill_in_targets_text:
            'Vul uw streefwaarden in. De lijst zal worden gevalideerd en goedgekeurd door Valacon.',
          confirm_approve_targets_title:
            'Weet u zeker dat u deze waarden wilt goedkeuren?',
          confirm_set_to_draft_title:
            'Weet je zeker dat je deze lijst wilt retourneren voor correcties?',
          confirm_set_to_draft_text:
            'U kunt een opmerking achterlaten voor de gebruiker met betrekking tot de benodigde correcties.',
          targets_approved: 'De Streefwaarden lijst is goedgekeurd.',
          indicators_not_approved_yet:
            'Huidige situatie is nog niet goedgekeurd.',
          indicators_approved: 'Huidige situatie is goedgekeurd',
          indicators_for_approval:
            '{num} Huidige situatie lijsten zijn in afwachting van goedkeuring',
          targets_for_approval:
            '{num} Streefwaarden in afwachting van goedkeuring',
          inactive_users:
            '{num} inactieve gebruikers | {num} inactieve gebruiker | {num} inactieve gebruikers',
          create_company: 'Maak een bedrijf',
          company_registration_title: 'Bedrijf registratie',
          house_suffix: 'Toevoeging',
          register_company_button: 'Registreer bedrijf',
          state: 'Provincie',
          back_to_targets_button: 'terug naar overzicht',
          back_to_indicators_button: 'terug naar overzicht',
          user: 'Gebruiker',
          ready_for_approval: 'Klaar voor goedkeuring',
          approved: 'Goedgekeurd',
          approve_targets_button: 'Goedkeuren',
          confirm_approve_targets_text:
            'Na goedkeuring kan de gebruiker deze niet meer wijzigen.',
          approve_targets_dialog_yes_button: 'Ja, goedkeuren',
          approve_targets_dialog_no_button: 'Nee',
          set_to_draft_button: 'Terugsturen voor correcties',
          adminNotes: 'Notities',
          set_to_draft_dialog_no_button: 'Nee',
          set_to_draft_dialog_yes_button:
            'Ja, stuur het terug naar de gebruiker',
          name: 'Naam',
          or: 'of',
          site_title1: 'Geef ze de Vijf!',
          date: 'Datum',
          more_info: 'meer informatie',
          ubn_number: 'UBN nummer',
          tank_number: 'Tank nummer',
          company_name: 'Bedrijfsnaam',
          street: 'Straat',
          house_number: 'Huisnummer',
          postcode: 'Postcode',
          city: 'Plaats',
          country: 'Land',
          coc_number: 'KVK number',
          vat_number: 'BTW number',
          cancel: 'Annuleren',
          cant_be_changed: 'Kan niet aangepast worden.',
          fill_in_indicators_text: 'Vul de huidige situatie in.',
          to_indicators_button: 'Ga naar huidige situatie',
          finish_indicators_text: 'Beeindig de huidige situatie',
          finish_targets_text: 'Beeindig de streefwaarden',
          previous_indicators_not_approved_yet:
            'Je kunt geen nieuwe huidige situatie toevoegen voordat de vorrige goedgekeurd is',
          company_tank_number: 'Bedrijfstanknummer',
          cannot_add_targets_before_indicators_approval:
            'Je kunt geen Streefwaarden toevoegen voordat de Huidige situatie is goedgekeurd.',
          row_click_for_details: 'Klik op rij voor meer informatie',
          edit_user: 'Bewerk gebruiker',
          edit_user_dialog_title: 'Bewerk gebruiker',
          address: 'Adres',
          company_details: 'Bedrijfsgegevens',
          user_details: 'Gebruikersdetails',
          gdpr_disagree_button: 'Ik ga niet akkoord',
          gdpr_agree_button: 'Ik ga akkoord',
          forum: 'Discussieplatform',
          dashboard_card_title_ActualLifeBalance: 'Actuele levenssaldo per koe',
          dashboard_card_title_LifeBalance: 'Levenssaldo bij afvoer per koe',
          dashboard_card_title_RollingAnualAvgProduction:
            'Rollend jaargemiddelde productie',
          dashboard_card_title_HerdLivespan: 'Actuele levensduur',
          dashboard_card_title_ProductiveLivespan:
            'Actuele productieve levensduur',
          dashboard_card_title_ActualLivespanProduction:
            'Actuele levensproductie',
          dashboard_card_title_Livespan: 'Levensduur bij afvoer',
          dashboard_card_title_ProductiveLivespanCulling:
            'Productieve levensduur bij afvoer',
          dashboard_card_title_LivespanProduction: 'Levensproductie bij afvoer',
          current_value: 'Huidige waarde',
          target_value: 'Streef waarde',
          due_date: 'd.d.',
          platform_avg_short: 'Platform gem.',
          platform_avg: 'Platformgemiddelde',
          total: 'Totaal',
          difference: 'Verschil',
          current: 'Huidig',
          target: 'Streven',
          forgot_password: 'Wachtwoord vergeten',
          send_reset_password_link: 'Wachtwoord opvragen',
          reset_password_form_title: 'Wachtwoord opnieuw instellen',
          save_password_button: 'Wachtwoord opslaan',
          reset_password_link_sent:
            'Reset wachtwoord link is verzonden naar uw e-mail',
          new_password_saved: 'Wachtwoord succesvol veranderd',
          reset_password_link_expired: 'Reset wachtwoord link verlopen',
          missing_input_data:
            'Sommige velden die worden gebruikt voor de berekening van "Levenssaldo bij afvoer" hebben onjuiste waarden',
          is_user_active: 'Is actief',
          go_to_user_list: 'Ga naar gebruikerslijst',
          user_profile_created:
            'Bedankt voor je registratie, er is een email verzonden naar je opgegeven e-mailadres. Hierin meer informatie om je gebruikers account te activeren.',
          pay_with_mollie_link: 'Betaal met Mollie / iDeal',
          payment_status: 'Betalingsstatus: {status}',
          payment_status_expired: 'verlopen',
          payment_status_failed: 'mislukt',
          payment_status_canceled: 'geannuleerd',
          payment_status_paid: 'betaald',
          payment_pending_text:
            'De betaling wordt verwerkt. Uw account zou binnen enkele minuten actief moeten zijn',
          problem_with_payment:
            'Er is een probleem opgetreden met uw betaling. Neem dan contact op met ons Geef ze de vijf team',
          manual: 'Kennisplatform',
          coming_soon: 'Binnenkort beschikbaar',
        },
        companyDetails: {
          title: 'Bedrijfsgegevens melkveehouderij',
          description: '',
          herdSize: {
            title: 'Aanwezige melkkoeien (inclusief droog)',
            description: 'Gemiddeld aanwezige koeien incl. droogstaande',
          },
          avgHerdLifePerCow: {
            title: 'Gemiddelde Leeftijd aanwezige koeien',
            description:
              'Uit MPR jaaroverzicht. Vul de jaren en maanden apart in.',
          },
          lifelongProductionPerCow: {
            title: 'Levensproductie aanwezige koeien',
            description: '',
          },
          avgLifespanCulledCows: {
            title: 'Gemiddelde leeftijd afgevoerd koeien',
            description: 'Uit MPR jaaroverzicht',
          },
          avgLifelongProductionPerCulledCow: {
            title: 'Levensproductie afgevoerde koeien',
            description:
              'Uit MPR jaaroverzicht. Vul de jaren en maanden apart in.',
          },
          animalsIntroducedPastYear: {
            title: 'Aantal ingestoken dieren afgelopen 12 maanden',
            description: '',
          },
          animalsCulledPastYear: {
            title:
              'Aantal afgevoerde dieren (slacht/dood/vetweiders) afgelopen 12 maanden',
            description: 'Zie MPR jaaroverzicht',
          },
          animalsInFirstLactationCulledPastYear: {
            title: 'Aantal afgevoerde vaarzen afgelopen 12 mnd',
            description: 'Zie Duurzaamheidsmonitor in managementprogramma',
          },
          herdSizeAccordingToLatestMPR: {
            title: 'Aantal aanwezige koeien laatste MPR',
            description:
              'Inclusief de vaarzen. Zie daarvoor de Duurzaamheidsmonitor in managementprogramma',
          },
          rollingAnualAvgProduction: {
            title: 'Rollend jaargemiddelde productie',
            description:
              'Alleen de afgevoerde vaarzen, ook die direct na afkalven zijn afgevoerd.',
          },
          rollingAnnualAverageFatContent: {
            title: 'Vetgehalte rollend jaargemiddelde',
            description: 'Wordt automatisch berekend',
          },
          rollingAnnualAverageProteinContent: {
            title: 'Eiwitgehalte rollend jaargemiddelde',
            description: 'Zie MPR jaaroverzicht',
          },
          rollingAnnualAverageLactoseContent: {
            title: 'Lactosegehalte rollend jaargemiddelde',
            description: 'Zie MPR jaaroverzicht',
          },
          avgUreaConcentration: {
            title: 'Gem. ureumgetal',
            description: 'Zie MPR jaaroverzicht',
          },
          calvingIntervalInDays: {
            title: 'Tussenkalftijd in dagen',
            description:
              'Zie MPR jaaroverzicht onderste tabel "monstername in statistiekjaar"',
          },
          maturity: {
            title: 'Rijpheid',
            description:
              'Zie MPR jaaroverzicht onderste tabel "monstername in statistiekjaar"',
          },
        },
        indicatorsDairyCattle: {
          title: 'Overige kengetallen melkvee',
          description: 'Kengetallen jongvee',
          daysDry: {
            title: 'Droogstandsdagen',
          },
          avgFeedCostsPerKgMilk: {
            title: 'Gemiddelde voerkosten per kg melk',
            description:
              'Totale kosten aan krachtvoer, grondstoffen, bijproducten en eigen en aangekocht ruwvoer',
          },
          kgConcentratesPer100KgMilk: {
            title: 'Kg krachtvoer per 100 kg melk',
            description: 'Meerekenen mengvoer en grondstoffen en bijproducten',
          },
          numInseminationsPerPregnancyDairyCows: {
            title: 'Aantal inseminaties per dracht melkkoeien',
            description:
              'Aantal inseminaties per dracht: Kijk daarover op MPR snelzicht of STO-vruchtbaarheid en neem het jaargemiddelde (zie tabel 5).',
          },
          percCowsInseminatedWithSexedSemen: {
            title: 'Percentage koeien met gesext sperma',
          },
          avgIntervalCalvingFirstInsemination: {
            title: 'Gemiddelde interval afkalven - eerste inseminatie',
          },
          avgIntervalBetweenInseminations: {
            title: 'Gemiddelde interval tussen de inseminaties',
          },
          percCowsInseminatedWithBeefBulls: {
            title: 'Percentage koeien geïnsemineerd met vleesras',
          },
          numInseminationsWithBeefBullsPerPregnancy: {
            title: 'Aantal inseminaties vleesras per dracht',
          },
          dailyDoseAntibiotics: {
            title: 'Dierdagdosering (DDD in milligram antibiotica)?',
          },
          numCowsWithMastitisPerYear: {
            title: 'Aantal gevallen van mastitis per jaar',
            description:
              'Noteer het totaal gevallen inclusief de herhalingsgevallen. Het aantal gevallen kan dus meer zijn dan het aantal koeien.',
          },
          percMastitisTreatment: {
            title: '% mastitisbehandelingen',
          },
          avgBulkTankSomaticCellsLastYear: {
            title: 'Tankcelgetal gemiddeld laatste jaar',
            description:
              'Tankcelgetal: Kijk daarvoor in de laatste MPR Snelzicht en neem het totaal gedeeld door 13. ',
          },
          avgPercCowsWithIncreasedSCC: {
            title: '% verhoogd celgetal? (gemiddeld)',
          },
          avgPercCowsWithNewIncreasedSCC: {
            title: '% nieuw verhoogd? (gemiddeld)',
          },
          numCowsWithMilkFeverPerYear: {
            title: 'Aantal koeien met melkziekte per jaar',
            description:
              ' Aantal koeien met kalfziekte: aantal gebruikte CaMg infusen waarbij koeien die meerdere flessen krijgen wel als één worden gerekend. Als u meestal 2 flessen per koe nodig hebt dan is het aantal koeien met kalfziekte de helft van het aantal flessen.',
          },
          percCowsWithMilkFever: {
            title: '% koeien met melkziekte',
          },
          numCowsWithKetosis: {
            title: 'Aantal koeien met slepende melkziekte per jaar',
            description:
              'Aantal koeien met slepende melkziekte: neem de ketosegevallen van minimaal 5 controles.  Ze staan in de MPR-voeding. Deel het totaal door het aantal maanden en vermenigvuldig met 12. Bijvoorbeeld (3+6+9+2+4)/5 x 12 = 58. Bij deelname aan Deens systeem het aantal ketosegevallen optellen. U bent vrij om een andere betrouwbare methode te kiezen.',
          },
          percCowsWithKetosis: {
            title: '% slepende melkziekte',
          },
          numCowsWithRumenAcidosisPerYear: {
            title: 'Aantal koeien met pensverzuring per jaar',
            description:
              'Aantal koeien met pensverzuring: neem het totaal aantal gevallen uit de MPR over minimaal 5 maanden, deel het totaal door het aantal maanden en vermenigvuldig met 12. Bijvoorbeeld (2+4+1+0+3)/5 x 12 = 24. Let erop dat het aantal gevallen in het seizoen sterk kan variëren. Hoe meer maanden u neemt hoe beter. U bent vrij om een andere betrouwbare methode te kiezen. ',
          },
          percCowsWithRumenAcidosis: {
            title: '% pensverzuring',
          },
          numAbomasumReplacements: {
            title: 'Aantal lebmaagbehandelingen',
            description:
              'noteer het werkelijk aantal behandelingen wegens lebmaagdraaiing/verplaatsing',
          },
          numTreatmentsAcuteEndometritisPerYear: {
            title: 'Aantal behandelingen voor baarmoederontsteking per jaar',
            description:
              'Neem het aantal behandelingen voor  acute baarmoederontsteking, chronische baarmoederonsteking (witvuilers) en nageboorteproblemen.',
          },
          percCowsWithAcuteEndomitritis: {
            title: '% baarmoederontstekingen',
          },
          numCowsWithRetainingPlacenta: {
            title: 'Aantal koeien dat aan de nageboorte is blijven staan',
          },
          percCowsWithRetainedPlacenta: {
            title: '% niet afkomen van de nageboorte',
          },
          numCowsWithChronicEndometritis: {
            title: 'Aantal koeien met chronische baarmoederontsteking',
          },
          percCowsWithChronicEndometritis: {
            title: '% koeien met chronische baarmoederontsteking',
          },
          numCowsWithHeavyBirthsPerYear: {
            title: 'Aantal zware geboortes per jaar',
          },
          avgPercCowsWithHeavyBirths: {
            title: '% zware geboortes per jaar',
          },
          numTreatmentsFeetProblemsPerYear: {
            title: 'Aantal behandelingen voor klauwaandoeningen per jaar',
            description:
              'neem het aantal behandelingen vanwege een echt probleem (infectie, defect, aandoening) inclusief de herhalingsgevallen. Het kunnen er dus meer zijn dan het aantal koeien. ',
          },
          percTreatmentsFeetProblemsPerYear: {
            title: '% behandelingen voor klauwaandoeningen per jaar',
            description:
              'Koppelbehandelingen zijn de behandelingen en controle van alle of groepen koeien op gezette tijden ongeacht een specifiek probleem. Dus geen behandeling bij droogzetten of op 100 dagen.',
          },
          numScheduledHoofTrimingsPerYear: {
            title: 'Aantal maal koppelbehandeling per jaar',
          },
          numCowsWithInjuredHocks: {
            title: 'Aantal koeien met beschadigde hakken',
          },
          percCowsWithInjuredHocks: {
            title: '% melkkoeien met beschadigde en kapotte hakken',
          },
          numCowsWithSwollenHocks: {
            title: 'Aantal koeien met dikke hakken',
          },
          percCowsWithSwollenHocks: {
            title: '% melkkoeien met dikke hakken',
          },
          numCowsWithInjuredFrontKnees: {
            title: 'Aantal koeien met dikke knieën',
          },
          percCowsWithInjuredFrontKnees: {
            title: '% melkkoeien met dikke knieën',
          },
          grazing: {
            title: 'Beweiding (o=onbeperkt, b=beperkt, s=in de stal)',
          },
        },
        indicatorsYoungStock: {
          title: 'Kengetallen jongvee',
          description: '',
          percStillBirthsAndDiedWithin48HoursAfterBirth: {
            title: '% Doodgeboren en sterfte binnen 48 uur',
            description:
              'Neem het aantal doorgeboren kalveren plus de kalveren die uiterlijk de dag van erna nog sterven als gevolg van zware geboortes, aangeboren afwijkingen etc.',
          },
          keepingAllCalvesOrRemovingRedundant: {
            title: 'Vaarskalveren aanhouden A of uitselecteren U',
            description:
              'Als u de overtollige kalveren van een paar weken oud verkoopt, klik dan "U" aan en als u alles aanhoudt klik dan "A" aan. ',
          },
          avgNumberOfYoungStockPer10DairyCows: {
            title: 'Gemiddeld stuks jongvee per 10 melkkoeien',
          },
          numBullCalvesDiedFrom48HoursToSale: {
            title: 'Aantal gestorven stierkalveren vanaf 48 uur tot verkoop',
            description:
              'Levend geboren stierkalveren die gestorven zijn in de periode vanaf de dag na de geboortedag tot de leeftijd van ca. 14 dagen.',
          },
          numCalvesDiedFrom48HoursTo14DaysOfAge: {
            title: 'Aantal gestorven vaarskalveren vanaf 48 uur tot 14 dagen',
            description:
              'Vaarskalveren die gestorven zijn in de periode vanaf de dag na de geboortedag tot de leeftijd van 14 dagen.',
          },
          numCalvesDiedFrom14DaysOfAgeToWeaning: {
            title: 'Aantal gestorven vaarskalveren vanaf 14 dagen tot spenen',
            description:
              'Het gaat om de gestorven kalveren die van het bedrijf zijn afgevoerd',
          },
          percOfCalvesWithNavelInfection: {
            title: '% kalveren met navelontstekingen',
          },
          percCalvesWithDiarrheaFromBirthToWeaning: {
            title: '% kalveren met diarree in de periode tot spenen',
          },
          weaningAgeInWeeks: {
            title: 'Speenleeftijd in weken',
          },
          percCalvesWithDiarrheaAfterWeaning: {
            title: '% kalveren met diarree na spenen',
          },
          percCalvesWithLungDiseases: {
            title: '% kalveren met longaandoeningen',
          },
          ageAtWhichTheCalvesAreHousedInStalls: {
            title: 'Op hoeveel maanden gaan de kalveren naar de ligboxen?',
          },
          numCalvesDiedFromWeaningToInsemination: {
            title: 'Aantal gestorven kalveren van spenen tot insemineren',
            description:
              'Het gaat om de gestorven kalveren die van het bedrijf zijn afgevoerd',
          },
          numCalvesDiedFromInseminationToCalving: {
            title: 'Aantal gestorven vaarskalveren van insemineren tot kalven',
            description:
              'Het gaat om de gestorven kalveren die van het bedrijf zijn afgevoerd',
          },
          calvingAgeHeifersLastYearWrittenInMonths: {
            title: 'Afkalfleeftijd vaarzen afgelopen jaar in maanden',
            description:
              'Weergeven in maanden zoals aangegeven in het MPR snelzicht of STO vruchtbaarheid. Neem het jaargemiddelde.',
          },
          ageAtWhichInseminationOfHeifersStarts: {
            title: 'Op hoeveel maanden wordt begonnen met insemineren',
          },
          numInseminationsPerHeifer: {
            title: 'Inseminatiegetal pinken',
            description:
              'Noteer het inseminatiegetal uit het MPR snelzicht (zie tabel 7). Bij gebruik van een eigen stier, vul 1 in.',
          },
          percHeifersInseminatedWithBeefBreed: {
            title: 'Percentage pinken met vleesras geïnsemineerd',
          },
          percHeifersInseminatedWithSexedSemen: {
            title: 'Percentage pinken geïnsemineerd met gesext sperma',
          },
          inseminationAgeHeifersMonths: {
            title: 'Inseminatieleeftijd pinken in maanden',
            description: 'Deze waarde wordt automatisch berekend',
          },
          ageInMonthsCalvesAreNoLongerGivenCalfGrowers: {
            title:
              'Met hoeveel maanden krijgen de kalveren geen jongveebrok meer?',
            description:
              'Het gaat om de kalverkorrel of jongvee brok. Niet meerekenen het krachtvoer dat ze eventueel meekrijgen met het melkveerantsoen.',
          },
          calvesPasturesOrBuildings: {
            title: 'Kalveren weiden of opstallen (w=weiden, s=opstallen)',
          },
          yearlingsPasturesOrBuildings: {
            title: 'Pinken weiden of opstallen (w=weiden, s=opstallen)',
          },
        },
        economicIndicators: {
          title: 'Economische kengetallen',
          description: '',
          costsOfOwnLabor: {
            title: 'Kosten van de eigen arbeid',
            description:
              'Dit is het bruto bedrag dat u zou moeten betalen als u vreemde arbeid inhuurt. Een bedrijfshulp kost bruto ca. €35.',
          },
          manureDisposalPerKgPhosphate: {
            title:
              'Kg fosfaat mestafvoer (aanvoer in kg fosfaat negatief invullen)',
            description:
              'De afgevoerde fosfaat als u ook echt een mestoverschot heeft. Voert u mest aan van een overschotbedrijf noteer dat dan als een negatief getal (bijvoorbeeld -150).',
          },
          phosphateReferencePerKg: {
            title: 'Fosfaat referentie in kg',
            description: 'Totale referentie van jongvee en melkvee',
          },
          costsOfManureDisposalPerTon: {
            title:
              'Kosten mestafzet per ton inclusief evt. verwerking (€0 = geen mestafzet)',
            description:
              'Noteer hier de gemiddelde afzetkosten bij een mestoverschot. Heeft u geen overschot vul dan 0 in.',
          },
          avgSemenPriceBreedingBulls: {
            title: 'Gemiddelde spermaprijs van fokstieren',
            description:
              'De gemiddelde prijs die u afgelopen jaar heeft betaald',
          },
          avgSemenPriceBeefBulls: {
            title: 'Gemiddelde spermaprijs van BWB',
          },
          vetCostsPer100KgMilk: {
            title: 'Dierenartskosten per 100 kg melk',
            description:
              'De kosten die de dierenarts in rekening brengt voor een werk en medicijnen.',
          },
          cattleHasToBePurchased: {
            title: 'keuze indien (jong)vee moet worden aangekocht',
            description:
              'U kunt kiezen voor de aankoop van afgekalfde koeien, kalfvaarzen (hoogdrachtige pinken) of vaarskalveren',
          },
          isSoldForLife: {
            title: 'Worden kalfvaarzen/ vaarzen voor het leven verkocht?',
          },
          isRearingOutsourced: {
            title: 'Wordt de opfok uitbesteed',
          },
          calvesFreshMilkOrReplacement: {
            title: 'Krijgen de vaarskalveren poedermelk of koemelk',
          },
          bullBeefCalvesFreshMilkOrReplacement: {
            title: 'Krijgen stiertjes en vleeskalveren poedermelk of koemelk',
          },
        },
      },
      en: {
        companyDetails: {
          title: 'Company details',
          description: '',
          herdSize: {
            title: 'Herd size',
            description: 'Average present cows incl. dry ones',
          },
          avgHerdLifePerCow: {
            title: 'Average herd life per cow',
            description:
              'From MPR annual overview. Enter the years and months separately.',
          }, //computed?
          lifelongProductionPerCow: {
            title: 'Life production per cow',
            description:
              'From MPR annual overview. Enter the years and months separately.',
          },
          avgLifespanCulledCows: {
            title: 'Average lifespan of culled cows',
            description: 'From MPR annual overview',
          },
          avgLifelongProductionPerCulledCow: {
            title: 'Average life production per culled cow',
            description:
              'From MPR annual overview. Enter the years and months separately.',
          },
          animalsIntroducedPastYear: {
            title:
              'Number of animals introduced into the herd in the past 12 months',
            description:
              'From MPR annual overview. Enter the years and months separately.',
          },
          animalsCulledPastYear: {
            title:
              'Number of animals culled (slaughter / dead / fat pastures) in the past 12 months',
            description: 'See MPR annual overview',
          },
          animalsInFirstLactationCulledPastYear: {
            title:
              'Number of cows in their first lactation culled in last 12 months',
            description: 'See Sustainability monitor in management program',
          },
          herdSizeAccordingToLatestMPR: {
            title: 'Herd size according to the latest MPR',
            description:
              'Including the heifers. See the Sustainability monitor in the management program for this',
          },
          rollingAnualAvgProduction: {
            title: 'Rolling annual average production',
            description:
              'Only the heifers that have been removed, including those immediately after calving.',
          }, //computed?
          rollingAnnualAverageFatContent: {
            title: 'Fat content rolling annual average',
            description: 'Is calculated automatically',
          },
          rollingAnnualAverageProteinContent: {
            title: 'Protein content rolling annual average',
            description: 'See MPR annual overview',
          },
          rollingAnnualAverageLactoseContent: {
            title: 'Lactose content rolling annual average',
            description: 'See MPR annual overview',
          },
          avgUreaConcentration: {
            title: 'Avg. urea concentration in milk',
            description: 'See MPR annual overview',
          },
          calvingIntervalInDays: {
            title: 'Calving interval in days',
            description:
              'See MPR annual overview bottom table "sampling in statistical year"',
          },
          maturity: {
            title: 'Maturity',
            description:
              'See MPR annual overview bottom table "sampling in statistical year"',
          },
        },
        indicatorsDairyCattle: {
          $id: '#indicatorsDairyCattle',
          type: 'object',
          title: 'Other indicators for dairy cattle',
          properties: {
            daysDry: {
              title: 'Days dry',
            },
            avgFeedCostsPerKgMilk: {
              title: 'Average feed costs per kg of milk',
              description:
                'Total costs for concentrates, raw materials, by-products and own and purchased roughage',
            }, //computed
            kgConcentratesPer100KgMilk: {
              title: 'Kg concentrates per 100 kg of milk',
              description:
                'Including compound feed and raw materials and by-products',
            },
            numInseminationsPerPregnancyDairyCows: {
              title: 'Number of inseminations per pregnancy dairy cows',
              description:
                'Number of inseminations per pregnancy: Look at MPR quick view or STO fertility and take the annual average (see table 5).',
            },
            percCowsInseminatedWithSexedSemen: {
              title: 'Percentage of cows inseminated with sexed semen',
            },
            avgIntervalCalvingFirstInsemination: {
              title: 'Average interval calving - first insemination',
            },
            avgIntervalBetweenInseminations: {
              title: 'Average interval between inseminations',
            },
            percCowsInseminatedWithBeefBulls: {
              title: 'Percentage of cows inseminated with beef bulls',
            },
            numInseminationsWithBeefBullsPerPregnancy: {
              title: 'Number of inseminations with beef bulls per pregnancy',
            },
            dailyDoseAntibiotics: {
              title: 'Daily dose (DDD In milligram antibiotics)',
            },
            numCowsWithMastitisPerYear: {
              title: 'Number of cows with mastitis per year',
              description:
                'Record the total cases including the repeat cases. The number of cases can therefore be more than the number of cows.',
            },
            percMastitisTreatment: {
              title: '% mastitis treatments',
            },
            avgBulkTankSomaticCellsLastYear: {
              title: 'Average bulk tank somatic cell count last year',
              description:
                'Tank cell count: Look in the last MPR Snelzicht and take the total divided by 13.',
            },
            avgPercCowsWithIncreasedSCC: {
              title: '% of cows with increased SCC (average)',
            },
            avgPercCowsWithNewIncreasedSCC: {
              title: '% of cows with new increased SCC (average)',
            },
            numCowsWithMilkFeverPerYear: {
              title: 'Number of cows with milk fever per year',
              description:
                'Number of cows with calf disease: number of used CaMg infusions where cows that receive several bottles are counted as one. If you usually need 2 bottles per cow, the number of cows with calf disease is half the number of bottles',
            },
            percCowsWithMilkFever: {
              title: 'Percentage of cows with milk fever',
            },
            numCowsWithKetosis: {
              title: 'Number of cows with ketosis',
              description:
                'Number of cows with lingering milk disease: take the ketosis cases of at least 5 checks. They are in the MPR power supply. Divide the total by the number of months and multiply by 12. For example (3 + 6 + 9 + 2 + 4) / 5 x 12 = 58. Add the number of ketosis cases when participating in the Danish system. You are free to choose another reliable method',
            },
            percCowsWithKetosis: {
              title: '% of cows with ketosis',
            },
            numCowsWithRumenAcidosisPerYear: {
              title: 'Number of cows with rumen acidosis per year',
              description:
                'Number of cows with rumen acidification: take the total number of cases from the MPR over at least 5 months, divide the total by the number of months and multiply by 12. For example (2 + 4 + 1 + 0 + 3) / 5 x 12 = 24. Please note that the number of cases in the season can vary greatly. The more months you take, the better. You are free to choose another reliable method',
            },
            percCowsWithRumenAcidosis: {
              title: '% of cows with rumen acidosis',
            },
            numAbomasumReplacements: {
              title: 'Number of abomasum replacements',
              description:
                'Note the actual number of treatments due to abdominal stomach rotation / displacement',
            },
            numTreatmentsAcuteEndometritisPerYear: {
              title: 'Number of treatments for acute endometritis per year',
              description:
                'Take the number of treatments for acute uterine inflammation, chronic uterine inflammation (white waste) and afterbirth problems',
            },
            percCowsWithAcuteEndomitritis: {
              title: '% of cows with acute endomitritis',
            },
            numCowsWithRetainingPlacenta: {
              title: 'Number of cows with retaining placenta',
            },
            percCowsWithRetainedPlacenta: {
              title: '% of cows with retained placenta',
            },
            numCowsWithChronicEndometritis: {
              title: 'Number of cows with chronic endometritis',
            },
            percCowsWithChronicEndometritis: {
              title: '% of cows with chronic endometritis',
            },
            numCowsWithHeavyBirthsPerYear: {
              title: 'Number of cows with heavy births per year',
            },
            avgPercCowsWithHeavyBirths: {
              title: '% of cows with heavy births (average)',
            },
            numTreatmentsFeetProblemsPerYear: {
              title: 'Number of treatments for feet problems per year',
              description:
                'Take the number of treatments due to a real problem (infection, defect, condition) including recurrence cases. It can therefore be more than the number of cows',
            },
            percTreatmentsFeetProblemsPerYear: {
              title: '% of treatments for feet problems per year',
              description:
                'Couple treatments are the treatments and control of all or groups of cows at regular intervals regardless of a specific problem. So no treatment for drying out or on 100 days.',
            },
            numScheduledHoofTrimingsPerYear: {
              title: 'Number of sceduled hoof trimings per year',
            },
            numCowsWithInjuredHocks: {
              title: 'Number of cows with injured hocks',
            },
            percCowsWithInjuredHocks: {
              title: '% of cows with injured hocks',
            },
            numCowsWithSwollenHocks: {
              title: 'Numer of cows with swollen hocks',
            },
            percCowsWithSwollenHocks: {
              title: '% of cows with swollen hocks',
            },
            numCowsWithInjuredFrontKnees: {
              title: 'Number of cows with injured front knees',
            },
            percCowsWithInjuredFrontKnees: {
              title: '% of cows with injured front knees',
            },
            grazing: {
              title: 'Grazing',
            },
          },
        },
        indicatorsYoungStock: {
          title: 'Indicators young stock',
          properties: {
            percStillBirthsAndDiedWithin48HoursAfterBirth: {
              title: '% Still births and died within 48 hours after birth',
              description:
                'Take the number of calves born again plus the calves that still die the next day due to serious births, birth defects etc.',
            },
            keepingAllCalvesOrRemovingRedundant: {
              title: 'Keeping all calves or removing redundants calves',
              description:
                'If you sell the surplus calves of a few weeks old, click on "U" and if you keep everything on, click on "A"',
              enum: ['keeping', 'removing'],
            },
            avgNumberOfYoungStockPer10DairyCows: {
              title: 'Average number of young stock per 10 dairy cows',
            },
            numBullCalvesDiedFrom48HoursToSale: {
              title: 'Number of bull calves died from 48 hours to sale',
              description:
                'Live-born bull calves who died in the period from the day after the birth to the age of about 14 days',
            },
            numCalvesDiedFrom48HoursTo14DaysOfAge: {
              title: 'Number of calves died from 48 hours to 14 days of age',
              description:
                'Heifer calves that have died in the period from the day after the day of birth to the age of 14 days',
            },
            numCalvesDiedFrom14DaysOfAgeToWeaning: {
              title: 'Number of calves died from 14 days of age to weaning',
              description:
                'This concerns the dead calves that have been removed from the farm',
            },
            percOfCalvesWithNavelInfection: {
              title: '% of calves with navel infection',
            },
            percCalvesWithDiarrheaFromBirthToWeaning: {
              title: '% calves with diarrhea from birth to weaning',
            },
            weaningAgeInWeeks: {
              title: 'Weaning age in weeks',
            },
            percCalvesWithDiarrheaAfterWeaning: {
              title: '% calves with diarrhea after weaning',
            },
            percCalvesWithLungDiseases: {
              title: '% calves with lung diseases',
            },
            ageAtWhichTheCalvesAreHousedInStalls: {
              title: 'Age at which the calves are housed in stalls',
            },
            numCalvesDiedFromWeaningToInsemination: {
              title: 'Number of calves died from weaning to insemination',
              description:
                'This concerns the dead calves that have been removed from the farm',
            },
            numCalvesDiedFromInseminationToCalving: {
              title: 'Number of calves died from insemination to calving',
              description:
                'This concerns the dead calves that have been removed from the farm',
            },
            calvingAgeHeifersLastYearWrittenInMonths: {
              title: 'Calving age heifers last year written in months',
              description:
                'Display in months as indicated in the MPR quick view or STO fertility. Take the annual average.',
            },
            ageAtWhichInseminationOfHeifersStarts: {
              title: 'Age at which insemination of heifers starts',
            },
            numInseminationsPerHeifer: {
              title: 'Number of inseminations per heifer',
              description:
                'Record the insemination number from the MPR quick view (see Table 7). When using your own bull, enter 1.',
            },
            percHeifersInseminatedWithBeefBreed: {
              title: '% of heifers inseminated with beef breed',
            },
            percHeifersInseminatedWithSexedSemen: {
              title: 'Percentage of heifers inseminated with sexed semen',
            },
            inseminationAgeHeifersMonths: {
              title: 'Insemination age heifers in months',
              description: 'This value is calculated automatically',
            },
            ageInMonthsCalvesAreNoLongerGivenCalfGrowers: {
              title:
                'At what age in months calves are no longer given calf growers?',
              description:
                'It is about the calf grain or young cattle chunk. Do not include the concentrate that they may receive with the dairy cattle ration.',
            },
            calvesPasturesOrBuildings: {
              title: 'Calves pastures or buildings',
            },
            yearlingsPasturesOrBuildings: {
              title: 'Yearlings pastures or buildings',
            },
          },
        },
        economicIndicators: {
          title: 'Economic indicators',
          properties: {
            costsOfOwnLabor: {
              title: 'Costs of own labor',
              description:
                'This is the gross amount that you would have to pay if you were hiring foreign labor. Company assistance costs approximately € 35 gross.',
            },
            manureDisposalPerKgPhosphate: {
              title:
                'Manure disposal in kgs phosphate (if manure is supplied enter negative phosphate supply in kg)',
              description:
                'The removed phosphate if you really have a manure surplus. If you supply manure from a surplus company, note it as a negative number (for example -150).',
            },
            phosphateReferencePerKg: {
              title: 'Phosphate reference in kg',
              description: 'Total reference of young cattle and dairy cattle',
            },
            costsOfManureDisposalPerTon: {
              title:
                'Costs of manure disposal per ton including manure treatment costs (€ 0 = no manure disposal)',
              description:
                'Record here the average disposal costs for a manure surplus. If you do not have a surplus, enter 0.',
            },
            avgSemenPriceBreedingBulls: {
              title: 'Average semen price breeding bulls',
              description: 'The average price that you paid last year',
            },
            avgSemenPriceBeefBulls: {
              title: 'Average semen price beef bulls',
            },
            vetCostsPer100KgMilk: {
              title: 'Veterinary costs per 100 kg of milk',
              description:
                'The costs that the vet charges for work and medication.',
            },
            cattleHasToBePurchased: {
              title: 'Choice if (young) cattle has to be purchased',
              description:
                'You can choose to purchase calved cows, calf heifers (high-bearing heifers) or heifers',
            },
            isSoldForLife: {
              title: 'Are claves / heifers sold for life?',
            },
            isRearingOutsourced: {
              title: 'Is the rearing outsourced',
            },
            calvesFreshMilkOrReplacement: {
              title: 'Are the calves given fresh milk or milk replacers',
            },
            bullBeefCalvesFreshMilkOrReplacement: {
              title:
                'Are bull calves and beef calves given milk replacers of fresh milk',
            },
          },
        },
      },
    },
  })
}
